module.exports = {
      id: "ic-swiss-20-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-swiss-20-usage",
      toString: function () {
        return this.url;
      }
    }